// components/Hero.jsx
import React from 'react';
import './Hero.css';
// z.B. in App.js oder in einer eigenen Hero.js–Komponente
export default function Hero() {
  return (
    <div className="hero">
      <img src="/banner_stundenplan.png" alt="Hero" />
    </div>
  );
}
